import { BrowserLogger, Logger } from "@ciaopeople/cp-shatsu/Logging";
import { SNHUBConfig} from "../SNHUBConfig.js";
import { SNHUBSessionFunctions } from "../SNHUBSessionFunctions.js";
import { SNHUBLogicPublicData } from "../SNHUBLogicPublicData.js";


export class SNHUBLogicPublicDataLocalImpl implements SNHUBLogicPublicData {


    private sessionFunctions: SNHUBSessionFunctions;

    constructor( private config: SNHUBConfig, cookieVersion: number) {

        this.sessionFunctions = new SNHUBSessionFunctions(
            this.config.cookies,
            "." + this.config.domain,
            this.config.cookiePath,
            cookieVersion,
            new BrowserLogger("SNHUB")
        );

        

    }


    private getCurrentToken(): string|null {
        return this.sessionFunctions.getToken();
    }

    public getSNUTokenAnyways(): Promise<string> {
        return Promise.resolve(this.getCurrentToken());
    }

}